export default "__VITE_ASSET__VDaS5M1b__"